import { trendingItems } from '@/mocks/trending';

export default function TrendingTable() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-5">
            Live Trending
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight text-balance">
            Hot Finds <span className="italic text-primary-500">Right Now</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            The most popular items from our pandabuyspreadsheet collection, ranked by community popularity and quality score.
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/70 bg-background-100">
                  <th className="text-left py-4 px-5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">#</th>
                  <th className="text-left py-4 px-5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Item</th>
                  <th className="text-left py-4 px-5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap hidden sm:table-cell">Category</th>
                  <th className="text-left py-4 px-5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap hidden md:table-cell">Quality</th>
                  <th className="text-left py-4 px-5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Price</th>
                  <th className="text-right py-4 px-5 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Link</th>
                </tr>
              </thead>
              <tbody>
                {trendingItems.map((item, idx) => (
                  <tr
                    key={item.id}
                    className="border-b border-background-200/50 hover:bg-background-100 transition-colors"
                  >
                    <td className="py-4 px-5 text-foreground-400 font-medium whitespace-nowrap">
                      {String(idx + 1).padStart(2, '0')}
                    </td>
                    <td className="py-4 px-5 font-semibold text-foreground-800 whitespace-nowrap">
                      {idx === 0 && (
                        <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-bold mr-2">
                          HOT
                        </span>
                      )}
                      {item.name}
                    </td>
                    <td className="py-4 px-5 text-foreground-600 whitespace-nowrap hidden sm:table-cell">
                      {item.category}
                    </td>
                    <td className="py-4 px-5 text-accent-600 whitespace-nowrap hidden md:table-cell">
                      {item.quality}
                    </td>
                    <td className="py-4 px-5 font-semibold text-primary-600 whitespace-nowrap">
                      {item.price}
                    </td>
                    <td className="py-4 px-5 text-right whitespace-nowrap">
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener nofollow"
                        className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-xs font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        View <i className="ri-arrow-right-up-line text-xs"></i>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}